import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('DOCUMENT_COUNT')